import { Location } from 'vue-router'
import { DataCollectionCollection as Data } from '@/typings/api/DataCollection'

import { dateFormatter } from '@/helpers/dateFormatter'
import { EDIT, VIEW, DELETE } from '@/helpers/enums/table-actions'
import { TPL_UPLOAD, TPL_DOWNLOAD } from './table-actions'
import { FORM_TEMPLATE_ROUTES } from '@/views/FormTemplates/utils'


export const TABLE_ACTIONS_ADMIN = Object.freeze([
  TPL_DOWNLOAD,
  VIEW,
])

export const TABLE_ACTIONS = Object.freeze([
  TPL_DOWNLOAD,
  TPL_UPLOAD,
  EDIT,
  VIEW,
  DELETE,
])

const DATE_FORMAT = 'DD.MM.YYYY HH:mm'

const getViewRoute = (data: Data): Location => ({
  name: FORM_TEMPLATE_ROUTES.VIEW,
  params: { id: data.form_template.id.toString() },
})

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Название',
    value: 'name',
    sortable: false,
    cellClass: 'col-name',
  },
  {
    text: 'Кол-во участников',
    value: 'participants_count',
    sortable: false,
    cellClass: 'col-ates',
  },
  {
    text: 'Шаблон Веб-формы',
    value: 'form_template',
    sortable: false,
    cellClass: 'col-form_template',
    getRoute: getViewRoute,
    field: (_: Data['form_template']) => _.name,
  },
  {
    text: 'Период',
    value: 'period',
    sortable: false,
    width: 140,
    field: (_: unknown, data: Data) => [
      dateFormatter(data.start_at, DATE_FORMAT),
      dateFormatter(data.end_at, DATE_FORMAT),
    ].filter(Boolean).join(' - '),
  },
  {
    text: 'Сканирование',
    value: 'is_scannable',
    sortable: false,
    width: 115,
    align: 'center',
  },
])
